(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[348],{

/***/ 3627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_NavigationBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-avatar/dist/avatar/index.js
var avatar = __webpack_require__(8294);
var avatar_default = /*#__PURE__*/__webpack_require__.n(avatar);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-button/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(4936);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-divider/dist/divider/index.js
var divider = __webpack_require__(1508);
var divider_default = /*#__PURE__*/__webpack_require__.n(divider);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-icons/dist/index.esm.js + 540 modules
var dist_index_esm = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(8642);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/shared/PinfinanceLogo/index.tsx
var PinfinanceLogo = __webpack_require__(2386);
// EXTERNAL MODULE: ./src/components/shared/Text/index.tsx
var Text = __webpack_require__(1823);
// EXTERNAL MODULE: ./src/constants/customer.ts
var customer = __webpack_require__(5562);
// EXTERNAL MODULE: ./src/constants/internalUrls.ts
var internalUrls = __webpack_require__(7660);
// EXTERNAL MODULE: ./src/contexts/oauth/index.ts
var oauth = __webpack_require__(4854);
;// CONCATENATED MODULE: ./src/hooks/useElementClick/index.ts

var addClickListener = function(ref, onClick) {
    var handleWindowClick = function(e) {
        if (ref && onClick) {
            var node = e.target;
            while(node){
                if (ref.current === node) {
                    onClick();
                    return;
                }
                node = node.parentNode;
            }
        }
    };
    window.addEventListener("click", handleWindowClick);
    return function() {
        window.removeEventListener("click", handleWindowClick);
    };
};
var useClickHandler = function(onClick) {
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        return addClickListener(ref, onClick);
    }, [
        onClick,
        ref
    ]);
    return ref;
};
/* harmony default export */ var useElementClick = (useClickHandler);

// EXTERNAL MODULE: ./src/services/cookies/index.ts
var cookies = __webpack_require__(409);
// EXTERNAL MODULE: ./src/services/eventTracking/events/pinfinanceDiscovery/types.ts
var types = __webpack_require__(3779);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-icons/dist/ChevronDown16/index.js
var ChevronDown16 = __webpack_require__(2471);
var ChevronDown16_default = /*#__PURE__*/__webpack_require__.n(ChevronDown16);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/config.ts
var navigationLinks = [
    {
        label: "Beranda",
        href: "/",
        name: "pinfinance-home"
    },
    {
        label: "Komisi Instan",
        href: "/komisi-instan",
        name: "komisi-instan"
    },
    {
        label: "Bridging Loan",
        href: "/bridging-loan",
        name: "bridging-loan"
    }
];
var accountLinks = [
    {
        href: "dashboard",
        label: "Dashboard",
        name: "dashboard"
    },
    {
        href: "edit-profile",
        label: "Profil",
        name: "profile"
    }
];

// EXTERNAL MODULE: ./src/components/shared/NavigationBar/components/Account/styles.module.css
var styles_module = __webpack_require__(7949);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/components/Account/index.tsx










function Account(param) {
    var name = param.name, onLinkClick = param.onLinkClick, onLogOut = param.onLogOut, photoURL = param.photoURL, renderAvatarImage = param.renderAvatarImage;
    var createLinkClickHandler = (0,react.useCallback)(function(link) {
        return function(event) {
            if (typeof onLinkClick === "function") onLinkClick(link, event);
        };
    }, [
        onLinkClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (styles_module_default())["top-navigation__nav-item"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (styles_module_default())["top-navigation__account-btn"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((avatar_default()), {
                        name: name,
                        imageSrc: photoURL,
                        renderImage: renderAvatarImage,
                        size: "compact",
                        variant: "circular"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        component: "p",
                        typography: "body1",
                        margin: "0 5px",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ChevronDown16_default()), {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["top-navigation__menu__content-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default())["top-navigation__menu__content"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: (styles_module_default())["top-navigation__sub-menu"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                accountLinks.map(function(link) {
                                    var newLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                                        href: "/".concat(link.href)
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: newLink.href,
                                            legacyBehavior: true,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (styles_module_default())["top-navigation__sub-menu__link"],
                                                onClick: createLinkClickHandler(newLink),
                                                "data-testid": "account-link-".concat(newLink.name),
                                                children: newLink.label
                                            })
                                        })
                                    }, newLink.href);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (styles_module_default())["top-navigation__sub-menu__button"],
                                        onClick: onLogOut,
                                        children: "Keluar"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/NavigationBar/styles.module.css
var NavigationBar_styles_module = __webpack_require__(8761);
var NavigationBar_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_styles_module);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/utils.ts
var splitName = function(user) {
    if (!user) {
        return null;
    }
    var name = user.name.split(" ");
    return {
        firstName: name[0],
        lastName: name[1]
    };
};

;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/index.tsx

























var createNavlinkHandler = function(navLinkName) {
    return function() {
        if (navLinkName === "pinfinance-home") {
            cookies/* default.add */.Z.add({
                name: types/* PinfinanceDiscoveryOpenPageName.HOMEPAGE */.Yi.HOMEPAGE,
                value: JSON.stringify({
                    attribute: types/* PinfinanceDiscoveryAttr.HOMEPAGE_MENU */.dI.HOMEPAGE_MENU
                })
            });
        }
        if (navLinkName === "komisi-instan") {
            cookies/* default.add */.Z.add({
                name: types/* PinfinanceDiscoveryOpenPageName.ACD_HOMEPAGE */.Yi.ACD_HOMEPAGE,
                value: JSON.stringify({
                    attribute: types/* PinfinanceDiscoveryAttr.ACD_MENU */.dI.ACD_MENU
                })
            });
        }
        if (navLinkName === "bridging-loan") {
            cookies/* default.add */.Z.add({
                name: types/* PinfinanceDiscoveryOpenPageName.BRIDGING_LOAN_HOMEPAGE */.Yi.BRIDGING_LOAN_HOMEPAGE,
                value: JSON.stringify({
                    attribute: types/* PinfinanceDiscoveryAttr.BRIDGING_LOAN_MENU */.dI.BRIDGING_LOAN_MENU
                })
            });
        }
    };
};
var NavigationBar = function(param) {
    var extraMainNavigationItems = param.extraMainNavigationItems, extraMainNavigationItemsOverlay = param.extraMainNavigationItemsOverlay, extraNavigationItems = param.extraNavigationItems, extraNavigationItemsOverlay = param.extraNavigationItemsOverlay, _isShowMenu = param.isShowMenu, isShowMenu = _isShowMenu === void 0 ? true : _isShowMenu;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), isShowOverlayBurgerMenu = ref4[0], setIsShowOverlayBurgerMenu = ref4[1];
    var ref5 = (0,react.useState)(false), isShowOverlayProfile = ref5[0], setIsShowOverlayProfileMenu = ref5[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,oauth/* useOAuth */.F)(), user = ref6.user, logout = ref6.logout;
    var handleMenuToogle = (0,react.useCallback)(function() {
        setIsShowOverlayProfileMenu(false);
        setIsShowOverlayBurgerMenu(function(prevState) {
            return !prevState;
        });
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setIsShowOverlayProfileMenu(false);
        setIsShowOverlayBurgerMenu(function(prevState) {
            return !prevState;
        });
    }, []);
    var overlayRef = useElementClick(function() {
        return handleClose();
    });
    var handleProfileToogle = (0,react.useCallback)(function() {
        setIsShowOverlayBurgerMenu(false);
        setIsShowOverlayProfileMenu(function(prevState) {
            return !prevState;
        });
    }, []);
    var navLinks = (0,react.useMemo)(function() {
        if (!isShowMenu) {
            return null;
        }
        return navigationLinks.map(function(navLink) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: navLink.href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "aria-current": router.pathname == navLink.href ? "page" : undefined,
                    className: (0,clsx_m/* default */.Z)((NavigationBar_styles_module_default()).navigation__item, (NavigationBar_styles_module_default())["navigation__item-border"]),
                    onClick: createNavlinkHandler(navLink.name),
                    "data-testid": "lnk-navigation-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        typography: "body2",
                        color: "default",
                        children: navLink.label
                    })
                }, navLink.label)
            }, navLink.label);
        });
    }, [
        isShowMenu,
        router.pathname
    ]);
    var profileLinks = (0,react.useMemo)(function() {
        return accountLinks.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link.href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "aria-current": router.pathname == link.href ? "page" : undefined,
                    className: (NavigationBar_styles_module_default()).navigation__item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        typography: "body2",
                        color: "default",
                        children: link.label
                    })
                }, link.label)
            }, link.label);
        });
    }, [
        router.pathname
    ]);
    var customerTypeName = (0,react.useMemo)(function() {
        if ((user === null || user === void 0 ? void 0 : user.type) == customer/* CustomerType.BUSINESS */.d2.BUSINESS) {
            return customer/* customerTypeMapName.business */._l.business;
        }
        return customer/* customerTypeMapName.personal */._l.personal;
    }, [
        user
    ]);
    var handleLogout = (0,react.useCallback)(function() {
        router.push(internalUrls/* default.home */.Z.home);
        logout();
    }, [
        logout,
        router
    ]);
    var ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (NavigationBar_styles_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavigationBar_styles_module_default()).header__main__wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (NavigationBar_styles_module_default()).header__wrapper__left,
                        children: [
                            (isShowMenu || extraMainNavigationItems != null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (NavigationBar_styles_module_default()).burger__menu__button,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconButton */.hU, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Menu20Icon */.D0l, {}),
                                    testId: "btn-navbar-burger-menu",
                                    onClick: handleMenuToogle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: internalUrls/* default.home */.Z.home,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (NavigationBar_styles_module_default()).logo__link,
                                    href: "#",
                                    title: "Pinhome Financial",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinfinanceLogo/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (NavigationBar_styles_module_default()).header__wrapper__right,
                        children: [
                            navLinks,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (NavigationBar_styles_module_default())["header__extra-main-nav-item"],
                                children: extraMainNavigationItems
                            }),
                            extraNavigationItems,
                            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (NavigationBar_styles_module_default())["account-section"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Account, {
                                            name: (ref7 = (ref = splitName(user)) === null || ref === void 0 ? void 0 : ref.firstName) !== null && ref7 !== void 0 ? ref7 : "",
                                            onLogOut: handleLogout
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-testid": "icon-profile",
                                        className: (NavigationBar_styles_module_default())["account-section__mobile"],
                                        onClick: handleProfileToogle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((avatar_default()), {
                                            name: (ref8 = (ref1 = splitName(user)) === null || ref1 === void 0 ? void 0 : ref1.firstName) !== null && ref8 !== void 0 ? ref8 : "",
                                            size: "large",
                                            variant: "circular"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (isShowMenu || extraMainNavigationItems != null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "header-overlay-mobile",
                className: (0,clsx_m/* default */.Z)((NavigationBar_styles_module_default()).header__mobile__overlay, (0,_define_property/* default */.Z)({}, (NavigationBar_styles_module_default())["header__mobile__overlay-active"], isShowOverlayBurgerMenu === true)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NavigationBar_styles_module_default()).header__mobile__navigation__item__wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NavigationBar_styles_module_default()).navigation__item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PinfinanceLogo/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconButton */.hU, {
                                    fullWidth: false,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Close24Icon */.ERf, {}),
                                    onClick: handleMenuToogle,
                                    testId: "btn-navbar-close-overlay"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((divider_default()), {}),
                        navLinks,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: overlayRef,
                            children: extraMainNavigationItemsOverlay !== null && extraMainNavigationItemsOverlay !== void 0 ? extraMainNavigationItemsOverlay : extraMainNavigationItems
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NavigationBar_styles_module_default())["header__mobile__overlay-extra-nav-items"],
                            children: extraNavigationItemsOverlay !== null && extraNavigationItemsOverlay !== void 0 ? extraNavigationItemsOverlay : extraNavigationItems
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "header-overlay-profile-mobile",
                className: (0,clsx_m/* default */.Z)((NavigationBar_styles_module_default()).header__mobile__profile__overlay, (0,_define_property/* default */.Z)({}, (NavigationBar_styles_module_default())["header__mobile__profile-overlay-active"], isShowOverlayProfile === true)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NavigationBar_styles_module_default()).header__mobile__navigation__item__wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NavigationBar_styles_module_default()).navigation__item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PinfinanceLogo/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconButton */.hU, {
                                    fullWidth: false,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Close24Icon */.ERf, {}),
                                    onClick: handleProfileToogle,
                                    testId: "btn-navbar-close-overlay"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((divider_default()), {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NavigationBar_styles_module_default()).mobile__profile,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (NavigationBar_styles_module_default())["mobile__profile-content"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((avatar_default()), {
                                            name: (ref9 = (ref2 = splitName(user)) === null || ref2 === void 0 ? void 0 : ref2.firstName) !== null && ref9 !== void 0 ? ref9 : "",
                                            size: "large",
                                            variant: "circular"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    typography: "label1",
                                                    component: "p",
                                                    children: (ref3 = splitName(user)) === null || ref3 === void 0 ? void 0 : ref3.firstName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    typography: "body2",
                                                    component: "p",
                                                    children: customerTypeName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((divider_default()), {})
                            ]
                        }),
                        profileLinks,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (0,clsx_m/* default */.Z)((NavigationBar_styles_module_default()).navigation__item, (NavigationBar_styles_module_default())["mobile__profile-logout"]),
                            onClick: handleLogout,
                            "data-testid": "btn-logout-navbar-mobile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                typography: "body2",
                                children: "Keluar"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var shared_NavigationBar = (NavigationBar);


/***/ }),

/***/ 2386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PinfinanceLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_images__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(145);




function PinfinanceLogo(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: _constants_images__WEBPACK_IMPORTED_MODULE_3__/* .pinfinanceLogoUrl */ .SY,
            "data-testid": "img-pinfinanceLogo",
            alt: "pinfinance-logo",
            width: width !== null && width !== void 0 ? width : 133,
            height: height !== null && height !== void 0 ? height : 41
        })
    });
};


/***/ }),

/***/ 1823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8642);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4255);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




var Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "default" : _color, tmp = param.component, Component = tmp === void 0 ? "span" : tmp, margin = param.margin, textAlign = param.textAlign, _typography = param.typography, typography = _typography === void 0 ? "body1" : _typography;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        ref: ref,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text), (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default())["text_".concat(typography)]),
        style: {
            color: color === "inherit" ? "inherit" : "var(--color-text-".concat(color, ")"),
            margin: margin,
            textAlign: textAlign
        },
        children: children
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 8446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates_AppTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-icons/dist/index.esm.js + 540 modules
var index_esm = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/shared/Footer/components/LinkedIn.tsx

/* eslint-disable max-len */ var LinkedIn = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.14732 13.9997H0.232251V4.65281H3.14732V13.9997ZM1.68821 3.37781C0.756071 3.37781 0 2.60906 0 1.68094C6.67188e-09 1.23512 0.177865 0.807572 0.494466 0.492335C0.811068 0.177098 1.24047 0 1.68821 0C2.13596 0 2.56536 0.177098 2.88196 0.492335C3.19856 0.807572 3.37643 1.23512 3.37643 1.68094C3.37643 2.60906 2.62004 3.37781 1.68821 3.37781ZM14.0575 13.9997H11.1487V9.44969C11.1487 8.36531 11.1267 6.97469 9.63308 6.97469C8.11749 6.97469 7.88524 8.15281 7.88524 9.37156V13.9997H4.97331V4.65281H7.76911V5.92781H7.80991C8.19909 5.19344 9.14975 4.41844 10.5681 4.41844C13.5183 4.41844 14.0606 6.35281 14.0606 8.86531V13.9997H14.0575Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ var components_LinkedIn = (LinkedIn);

;// CONCATENATED MODULE: ./src/components/shared/Footer/config.ts
var aboutSection = [
    {
        label: "Pinfinance",
        href: "/",
        name: "pinfinance-home"
    },
    {
        label: "Komisi Instan",
        href: "/komisi-instan",
        name: "komisi-instan"
    },
    {
        label: "Bridging Loan",
        href: "/bridging-loan",
        name: "bridging-loan"
    }
];
var informationSection = [
    {
        label: "Ketentuan & Kebijakan Privasi",
        href: "/kebijakan-privasi",
        name: "ketentuan-kebijakan-privasi"
    }
];
var PinfinanceWhiteLogo = "https://pinhome-staging-public.s3.amazonaws.com/pinfinance-white-logo.png";

// EXTERNAL MODULE: ./src/components/shared/Footer/styles.module.css
var styles_module = __webpack_require__(3493);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/Footer/index.tsx







var footerNavSections = [
    {
        links: aboutSection,
        name: "about-section"
    },
    {
        links: informationSection,
        name: "information-section"
    }
];
var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (styles_module_default()).footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).footer__wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "".concat((styles_module_default()).footer__section, " ").concat((styles_module_default())["footer__section-logo__and__social"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).footer__logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: PinfinanceWhiteLogo,
                                width: 130,
                                height: 50,
                                alt: "pinfinance logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).footer__social,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (styles_module_default())["footer__social-item"],
                                    href: "https://www.linkedin.com/company/pinhomeid/",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "data-name": "linkedin",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkedIn, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (styles_module_default())["footer__social-item"],
                                    href: "https://www.youtube.com/channel/UCoiSd_yJjKpiRFe_ICfktFA",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "data-name": "youtube",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube32Icon */.X$j, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).footer__copyright,
                            children: [
                                new Date().getFullYear(),
                                " \xa9 PT. Properti Solusi Manajemen. All Rights Reserved."
                            ]
                        })
                    ]
                }),
                footerNavSections.map(function(param) {
                    var links = param.links, name = param.name;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "".concat((styles_module_default()).footer__section, " ").concat((styles_module_default())[name]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (styles_module_default()).footer__link,
                            children: links.map(function(link) {
                                var anchor = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: link.href,
                                    "data-name": link.name,
                                    className: (styles_module_default())["footer__link-anchor"],
                                    children: link.label
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (styles_module_default())["footer__link-item"],
                                    children: anchor
                                }, "link-".concat(link.name));
                            })
                        })
                    }, name);
                })
            ]
        })
    });
};
/* harmony default export */ var shared_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/shared/templates/AppTemplate/styles.module.css
var AppTemplate_styles_module = __webpack_require__(4344);
var AppTemplate_styles_module_default = /*#__PURE__*/__webpack_require__.n(AppTemplate_styles_module);
;// CONCATENATED MODULE: ./src/components/shared/templates/AppTemplate/index.tsx



var AppTemplate = function(param) {
    var children = param.children, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AppTemplate_styles_module_default()).layout,
        style: {
            backgroundColor: !color ? "inherit" : "var(--color-background-".concat(color, ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (AppTemplate_styles_module_default()).layout__main,
                children: children
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_Footer, {})
        ]
    });
};
/* harmony default export */ var templates_AppTemplate = (AppTemplate);


/***/ }),

/***/ 5562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ entityTypeOptions; },
/* harmony export */   "YB": function() { return /* binding */ LegalEntityType; },
/* harmony export */   "_l": function() { return /* binding */ customerTypeMapName; },
/* harmony export */   "d2": function() { return /* binding */ CustomerType; }
/* harmony export */ });
var CustomerType;
(function(CustomerType) {
    CustomerType["BUSINESS"] = "customer_type.business";
    CustomerType["PERSONAL"] = "customer_type.personal";
})(CustomerType || (CustomerType = {}));
var customerTypeMapName = {
    business: "Akun Badan Usaha",
    personal: "Akun Individual"
};
var LegalEntityType;
(function(LegalEntityType) {
    LegalEntityType["PT"] = "legal_entity.limited_company";
    LegalEntityType["CV"] = "legal_entity.cooperative";
    LegalEntityType["OTHERS"] = "legal_entity.others";
})(LegalEntityType || (LegalEntityType = {}));
var entityTypeOptions = [
    {
        label: "PT",
        value: LegalEntityType.PT
    },
    {
        label: "CV",
        value: LegalEntityType.CV
    },
    {
        label: "Lainnya",
        value: LegalEntityType.OTHERS
    }
];


/***/ }),

/***/ 145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ bniLogoUrl; },
/* harmony export */   "If": function() { return /* binding */ downloadGooglePlay; },
/* harmony export */   "KD": function() { return /* binding */ singaVerticalLogoUrl; },
/* harmony export */   "N0": function() { return /* binding */ danaSyariahLogoUrl; },
/* harmony export */   "Oq": function() { return /* binding */ permataLogoUrl; },
/* harmony export */   "PA": function() { return /* binding */ ojkLogoUrl; },
/* harmony export */   "S1": function() { return /* binding */ PromptIllustration; },
/* harmony export */   "SY": function() { return /* binding */ pinfinanceLogoUrl; },
/* harmony export */   "aw": function() { return /* binding */ bcaLogoUrl; },
/* harmony export */   "o$": function() { return /* binding */ downloadAppStore; },
/* harmony export */   "rC": function() { return /* binding */ dompetKilatLogoUrl; }
/* harmony export */ });
/* unused harmony exports singaLogoUrl, iconBridgingLoan */
var pinfinanceLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance-logo.png";
// PARTNERS
var ojkLogoUrl = "https://pinhome-web-assets.imgix.net/ojk-logo.png";
var singaLogoUrl = "https://pinhome-web-assets.imgix.net/agent-app/images/singa-logo.png";
var singaVerticalLogoUrl = "https://pinhome-web-assets.imgix.net/agent-app/images/singa-vertical-logo.png";
var dompetKilatLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance/partner/dompet-kilat.png";
var danaSyariahLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance/partner/dana-syariah.png";
var bniLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance/partner/bni-1.png";
var permataLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance/partner/permata.png";
var bcaLogoUrl = "https://pinhome-web-assets.imgix.net/pinfinance/partner/bca.png";
// DOWNLOAD APP
var downloadGooglePlay = "https://pinhome-web-assets.imgix.net/download-google-play.png";
var downloadAppStore = "https://pinhome-web-assets.imgix.net/download-app-store.png";
var iconBridgingLoan = "https://pinhome-web-assets.imgix.net/icon-bridging-loan.png";
//ILLUSTRATION
var PromptIllustration = "https://pinhome-web-assets.imgix.net/pinfinance/prompt-illustration.png";


/***/ }),

/***/ 7660:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var internalUrls = {
    home: "/",
    login: "/login",
    register: "/register",
    privacyPolicy: "/kebijakan-privasi",
    dasboard: "/dashboard",
    profile: "/profile",
    completeProfile: "/complete-profile",
    editProfile: "/edit-profile",
    blSubmission: "/pengajuan-bridging-loan",
    blConstructionSubmission: "/pengajuan-bridging-loan?type=bl_financing_type.construction",
    blNonConstructionSubmission: "/pengajuan-bridging-loan?type=bl_financing_type.non_construction",
    inProgressLoan: "/pengajuan-diproses",
    billingLoan: "/tagihan",
    historyLoan: "/riwayat",
    payment: "/pembayaran"
};
/* harmony default export */ __webpack_exports__["Z"] = (internalUrls);


/***/ }),

/***/ 3779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fx": function() { return /* binding */ PinfinanceDiscoveryButtonName; },
/* harmony export */   "Yi": function() { return /* binding */ PinfinanceDiscoveryOpenPageName; },
/* harmony export */   "dI": function() { return /* binding */ PinfinanceDiscoveryAttr; },
/* harmony export */   "oZ": function() { return /* binding */ PinfinanceDiscoveryButtonNameAttr; }
/* harmony export */ });
var PinfinanceDiscoveryOpenPageName;
(function(PinfinanceDiscoveryOpenPageName) {
    PinfinanceDiscoveryOpenPageName["HOMEPAGE"] = "homepage";
    PinfinanceDiscoveryOpenPageName["ACD_HOMEPAGE"] = "acd_homepage";
    PinfinanceDiscoveryOpenPageName["BRIDGING_LOAN_HOMEPAGE"] = "bridging_loan_homepage";
    PinfinanceDiscoveryOpenPageName["ACD_B2B_HOMEPAGE"] = "acd_b2b_homepage";
})(PinfinanceDiscoveryOpenPageName || (PinfinanceDiscoveryOpenPageName = {}));
var PinfinanceDiscoveryAttr;
(function(PinfinanceDiscoveryAttr) {
    PinfinanceDiscoveryAttr["HOMEPAGE_MENU"] = "homepage_menu";
    PinfinanceDiscoveryAttr["ACD_MENU"] = "acd_menu";
    PinfinanceDiscoveryAttr["BRIDGING_LOAN_MENU"] = "bridging_loan_menu";
    PinfinanceDiscoveryAttr["ACD_LEARN_MORE"] = "acd_learn_more";
    PinfinanceDiscoveryAttr["BRIDGING_LOAN_LEARN_MORE"] = "bridging_loan_learn_more";
    PinfinanceDiscoveryAttr["DIRECT_LINK"] = "direct_link";
    PinfinanceDiscoveryAttr["SIGN_IN_FORM"] = "sign_in_form";
    PinfinanceDiscoveryAttr["SIGN_UP_FORM"] = "sign_up_form";
})(PinfinanceDiscoveryAttr || (PinfinanceDiscoveryAttr = {}));
var PinfinanceDiscoveryButtonName;
(function(PinfinanceDiscoveryButtonName) {
    PinfinanceDiscoveryButtonName["ACD_SUBMISSION"] = "acd_submission";
    PinfinanceDiscoveryButtonName["ACD_B2B_SUBMISSION"] = "acd_b2b_submission";
    PinfinanceDiscoveryButtonName["CONTACT_US"] = "contact_us";
})(PinfinanceDiscoveryButtonName || (PinfinanceDiscoveryButtonName = {}));
var PinfinanceDiscoveryButtonNameAttr;
(function(PinfinanceDiscoveryButtonNameAttr) {
    PinfinanceDiscoveryButtonNameAttr["SERVICE_SELECTION"] = "service_selection";
    PinfinanceDiscoveryButtonNameAttr["NAVBAR"] = "navbar";
    PinfinanceDiscoveryButtonNameAttr["HERO_BANNER"] = "hero_banner";
    PinfinanceDiscoveryButtonNameAttr["INFO_BANNER"] = "info_banner";
    PinfinanceDiscoveryButtonNameAttr["SIMULATION_SECTION"] = "simulation_section";
    PinfinanceDiscoveryButtonNameAttr["BOTTOM_BANNER"] = "bottom_banner";
    PinfinanceDiscoveryButtonNameAttr["HELP_BANNER"] = "help_banner";
    PinfinanceDiscoveryButtonNameAttr["PERSONAL_DATA_FORM"] = "personal_data_form";
    PinfinanceDiscoveryButtonNameAttr["OCCUPATION_DATA_FORM"] = "occupation_data_form";
    PinfinanceDiscoveryButtonNameAttr["BANK_ACCOUNT_FORM"] = "bank_account_form";
    PinfinanceDiscoveryButtonNameAttr["INDIVIDUAL_DOCUMENT_UPLOAD"] = "individual_document_upload";
    PinfinanceDiscoveryButtonNameAttr["WA_FLOATING"] = "wa_floating";
    PinfinanceDiscoveryButtonNameAttr["NAV_BAR_ACD_B2B_APPLY"] = "nav_bar_acd_b2b_apply";
    PinfinanceDiscoveryButtonNameAttr["HERO_BANNER_ACD_B2B_APPLY"] = "hero_banner_acd_b2b_apply";
    PinfinanceDiscoveryButtonNameAttr["ACD_B2B_LOAN_PRODUCT_SELECTION"] = "acd_b2b_loan_product_selection";
    PinfinanceDiscoveryButtonNameAttr["SIMULATION_ACD_B2B_APPLY"] = "simulation_acd_b2b_apply";
    PinfinanceDiscoveryButtonNameAttr["BOTTOM_BANNER_ACD_B2B_APPLY"] = "bottom_banner_acd_b2b_app";
    PinfinanceDiscoveryButtonNameAttr["PROMO_BANNER_ACD_B2B_APPLY"] = "promo_banner_acd_b2b_apply";
})(PinfinanceDiscoveryButtonNameAttr || (PinfinanceDiscoveryButtonNameAttr = {}));


/***/ }),

/***/ 3493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__H4JiB","footer__section":"styles_footer__section__MUa0l","footer__logo":"styles_footer__logo__cLYp_","footer__social":"styles_footer__social__Jj1wm","footer__social-item":"styles_footer__social-item__73dZt","footer__copyright":"styles_footer__copyright__dr9UN","footer__link":"styles_footer__link__cuXoW","about-section":"styles_about-section__rqpCy","property-and-help-section":"styles_property-and-help-section__MbT4W","footer__link-item":"styles_footer__link-item___MLqq","footer__link-anchor":"styles_footer__link-anchor__kv3Eq","footer__wrapper":"styles_footer__wrapper__xwgUx","footer__section-logo__and__social":"styles_footer__section-logo__and__social__y0T9z"};

/***/ }),

/***/ 7949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top-navigation__menu__content-container":"styles_top-navigation__menu__content-container__J9X5_","top-navigation__sub-menu__button":"styles_top-navigation__sub-menu__button__PyyeR","top-navigation__sub-menu__link":"styles_top-navigation__sub-menu__link__tKppn","top-navigation__account-skeleton":"styles_top-navigation__account-skeleton__CPJkK","top-navigation__account-btn":"styles_top-navigation__account-btn__9U2_V","top-navigation__download-pca-link":"styles_top-navigation__download-pca-link__MFGH2","top-navigation__link":"styles_top-navigation__link__2C3Vm","top-navigation__menu-btn":"styles_top-navigation__menu-btn__1Si8C","top-navigation__nav-item":"styles_top-navigation__nav-item__M1VLi","top-navigation__menu__content":"styles_top-navigation__menu__content__7DIqk","top-navigation__sub-menu":"styles_top-navigation__sub-menu__ECj_J"};

/***/ }),

/***/ 8761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation__item":"styles_navigation__item__c1D_Y","header":"styles_header__fH6Bk","header__main__wrapper":"styles_header__main__wrapper__7oKf8","header__wrapper__right":"styles_header__wrapper__right__ittXr","header__wrapper__left":"styles_header__wrapper__left__CdUQQ","header__mobile__overlay":"styles_header__mobile__overlay__7pLDP","header__mobile__profile__overlay":"styles_header__mobile__profile__overlay__pU5ty","account-section__mobile":"styles_account-section__mobile__sC7xA","burger__menu__button":"styles_burger__menu__button__Qpp_q","header__extra-main-nav-item":"styles_header__extra-main-nav-item__QM4XM","logo__link":"styles_logo__link__j9ygY","account-section":"styles_account-section__EoFUe","header__mobile__profile-overlay-active":"styles_header__mobile__profile-overlay-active__xiFbU","header__mobile__overlay-active":"styles_header__mobile__overlay-active__Lryrf","header__mobile__navigation__item__wrapper":"styles_header__mobile__navigation__item__wrapper__X_cGZ","navigation__item-border":"styles_navigation__item-border__oRgop","header__mobile__overlay-extra-nav-items":"styles_header__mobile__overlay-extra-nav-items__dfp10","mobile__profile":"styles_mobile__profile__fJcHc","mobile__profile-content":"styles_mobile__profile-content__DWhDS","mobile__profile-logout":"styles_mobile__profile-logout__CnUzF"};

/***/ }),

/***/ 4255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__46n6Y","text_display1":"styles_text_display1__iWPcF","text_display2":"styles_text_display2__yrZgE","text_display3":"styles_text_display3__Isplt","text_heading1":"styles_text_heading1__ZsdoJ","text_heading2":"styles_text_heading2__iWbEP","text_heading3":"styles_text_heading3__bKQVf","text_body1":"styles_text_body1__M_uOD","text_body2":"styles_text_body2__IVaoA","text_body3":"styles_text_body3__yoiLk","text_label1":"styles_text_label1__gbRcp","text_label2":"styles_text_label2__Jr_Ru","text_label3":"styles_text_label3__xGw2G","text_label4":"styles_text_label4__Zlwce"};

/***/ }),

/***/ 4344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__X6_Dq"};

/***/ })

}]);